import { Form, useField } from 'bonfire-kindling';

import { OpportunityTypesInputDropdown } from 'components';
import { useOpportunityTypes } from 'helpers/opportunities';
import { compareFieldArray } from '../../utils';

const SavedSearchSettingsUpsertOpportunityTypes = () => {
  const field = useField('opportunityTypes');

  const { data: types } = useOpportunityTypes({
    onSuccess: types => field.input.onChange(types),
  });

  return (
    <Form.Field isEqual={compareFieldArray} name="opportunityTypes">
      {({ input }) => (
        <OpportunityTypesInputDropdown
          availableValues={types ?? []}
          currentValues={input.value}
          onChange={types => input.onChange(types)}
          TextFieldProps={{ fullWidth: true }}
        />
      )}
    </Form.Field>
  );
};

export default SavedSearchSettingsUpsertOpportunityTypes;
